import { gql } from 'apollo-boost'

const ADVANCED_PROBE_HTML_SESSION_REPORT_URL = gql`
  query advancedProbeHtmlSessionReportUrl($id: ID!) {
    advancedProbeHtmlSessionReportUrl(id: $id)
  }
`

export default ADVANCED_PROBE_HTML_SESSION_REPORT_URL
